import _ from 'lodash';
import React from 'react';
import { useHistory } from 'react-router-dom';

export default function useSearchParams(defaultKeyValuePairs) {
  const history = useHistory();
  const [_searchParams, _setSearchParams] = React.useState(() => new URLSearchParams(history.location.search));

  const setSearchParams = (keyValuePairs) => _setSearchParams((prev) => {
    const params = new URLSearchParams(prev);
    for (const [key, value] of _.entries(keyValuePairs)) {
      if (value == null) {
        params.delete(key);
      } else {
        params.set(key, value);
      }
    }
    history.location.search = `?${params.toString()}`;
    history.push(history.location.search);
    return params;
  });

  const searchParams = React.useMemo(() => {
    const params = new URLSearchParams(_searchParams);
    if (defaultKeyValuePairs) {
      for (const [key, value] of _.toPairs(defaultKeyValuePairs)) {
        if (!params.has(key) && !_.isNil(value)) {
          params.set(key, value);
        }
      }
    }
    return params;
  }, [_searchParams, defaultKeyValuePairs]);

  return [searchParams, setSearchParams];
}
